<script context="module">
  import preferences from '../preferences'

  export const pref = preferences('srsMonitor', { deviceIds: [], showSRSMonitor: false })
</script>

<script>
  import SidebarArea from "./SidebarArea.svelte";
  import Select from 'svelte-select'
  import {api} from '../api'

  const devices = api.devices.store

  function filterItems(items) {
    return Object.values(items).filter(i => i.type === 'SRS').map(i => ({ value: i.id, label: i.name }))
  }
</script>

<SidebarArea title='SRS Monitor'>
  <label>
    <input type="checkbox" bind:checked={$pref.showSRSMonitor} >
    Show SRS Monitor
  </label>
  <Select items={filterItems($devices)} isMulti bind:value={$pref.deviceIds} ></Select>
</SidebarArea>

<style>
</style>